document.addEventListener('DOMContentLoaded', function () {

  const modals = document.querySelectorAll('[data-modal]');
  if (modals) {
    modals.forEach((item) => {
      const btnClose = item.querySelector('.modal__close');
      btnClose.addEventListener('click', function () {
        modalClose(item);
      });
    })
  }

  const btnsOpenModal = document.querySelectorAll('[data-modal-open]');
  if (btnsOpenModal) {
    btnsOpenModal.forEach((item) => {
      item.addEventListener('click', function (e) {
        e.preventDefault();
        const id = item.getAttribute('data-modal-open');
        const modal = document.querySelector(`[data-modal="${id}"]`);
        if (item.hasAttribute('data-theme')) {
          modal.defaultTheme = item.getAttribute('data-theme');
        }
        modalOpen(modal);
      });
    })
  }

  function modalOpen(modal) {
    modal.classList.add('modal_show');
    document.body.classList.add('overflow');
    modal.dispatchEvent(new Event('open'))
  }

  function modalClose(modal) {
    modal.classList.remove('modal_show');
    document.body.classList.remove('overflow');
  }

  jQuery(window).on('dialog:beforecreate', e => {
    document
      .querySelectorAll('.ui-dialog .ui-dialog-buttonpane [data-drupal-messages]')
      .forEach(el => el.remove())
  })
});
